import type { ComponentProps } from "react"
import { Suspense } from "react"
import Skeleton from "@mui/material/Skeleton"

import { lazyWithReload } from "helpers/utils/staleChunk"

// Its own module on purpose. Declared next to the component, the importers would
// pull NewPasswordInput and zxcvbn into the initial bundle.
const NewPasswordInput = lazyWithReload(() => import("./NewPasswordInput"))

// Its own boundary too: without it the chunk suspends the nearest one, which hides the whole page.
const LazyNewPasswordInput = (props: ComponentProps<typeof NewPasswordInput>) => (
  <Suspense fallback={<Skeleton variant="rounded" height={40} sx={{ mb: "1rem" }} />}>
    <NewPasswordInput {...props} />
  </Suspense>
)

export default LazyNewPasswordInput
